export default __webpack_public_path__ + "static/media/image-cushion-r-w@3x.c1ce2d28.webp";